var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"section-mapa bg-default my-0",attrs:{"id":"mapa"}},[(!_vm.isMobile())?_c('mapa'):_c('panel-location',{attrs:{"mobile":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }